import {useEffect} from 'react'

import PayStubItemStore from 'models/PayStub/PayStubItem.store'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'
import useDebounce from 'src/utils/hooks/useDebounce'
import useUpdateEffect from 'src/utils/hooks/useUpdateEffect'

/** Triggers the calculation only if the user completed the filling of fields in the step one.
 * Also triggers the calculation after debounce time
 * if the payments date, state or dependentsAmount was changed
 */
export default function usePaystubItemCalculationTriggering(item: PayStubItemStore) {
	const payStubStore = usePayStubStore()
	const {paymentType, employmentType, employeeInfo, isAutoCalculation} = payStubStore

	const [, cancel] = useDebounce(
		() => {
			if (!payStubStore.isStepFiveDirty) return
			payStubStore.setIfShouldBeCalculated(false)
			item.calculate()
		},
		100,
		[
			employeeInfo.dependentsAmount,
			item.payDate,
			employeeInfo.maritalStatus,
			employeeInfo.state,
			employmentType,
			paymentType,
			isAutoCalculation,
		],
	)

	const [, cancelAfterPause] = useDebounce(
		() => {
			if (!payStubStore.isStepFiveDirty) return
			if (!payStubStore.isCalculationPause && payStubStore.shouldCalculateAfterPause) {
				payStubStore.setIfShouldBeCalculated(false)
				item.calculate()
			}
		},
		100,
		[payStubStore.shouldCalculateAfterPause, payStubStore.isCalculationPause],
	)

	useUpdateEffect(
		() => {
			if (!isAutoCalculation) {
				payStubStore.setIfShouldBeCalculated(false)
				payStubStore.validateCalculation()
			} else {
				if (!payStubStore.isStepFiveDirty) return
				payStubStore.setIfShouldBeCalculated(true)
				payStubStore.unValidateCalculation()
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			employeeInfo.dependentsAmount,
			item.payDate,
			employeeInfo.maritalStatus,
			employeeInfo.state,
			employmentType,
			paymentType,
			isAutoCalculation,
		],
	)

	useEffect(() => {
		if (payStubStore.isCalculationPause) {
			cancel()
			cancelAfterPause()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [payStubStore.isCalculationPause])

	useEffect(() => {
		cancel()
		cancelAfterPause()

		if (!payStubStore.isCalculationValid) {
			item.calculate()
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return [cancel]
}
